import { ReactComponent as New } from '../../../../assets/icons/new.svg';
import { ReactComponent as SmallNew } from '../../../../assets/icons/smallNew.svg';

import styled from 'styled-components';

interface ContainerProps {
  width: string;
  height: string;
  backgroundColor?: string;
  onClick?: () => void;
}

const Container = styled.div<ContainerProps>`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  flex-basis: ${(props) =>
    props.width !== undefined ? props.width : props.height};
  min-width: ${(props) => props.width};
  min-height: ${(props) => props.height};
  border-radius: 50%;
  background-color: ${(props) =>
    props.backgroundColor ?? props.theme.colors.grayBgLight};

  &:hover {
    cursor: ${(props) => (props.onClick ? 'pointer' : undefined)};
  }
`;

const NewIcon = styled(New)`
  position: absolute;
  bottom: 31px;
  left: 31px;
`;
const SmallNewIcon = styled(SmallNew)`
  position: absolute;
  bottom: 28px;
  left: 28px;
`;

interface LXIconProps {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  width: string;
  backgroundColor?: string;
  newAlarm?: boolean;
  opacity?: number;
  onClick?: () => void;
}

const LXIcon = (props: LXIconProps) => {
  return (
    <Container
      width={props.width}
      height={props.width}
      backgroundColor={props.backgroundColor}
      onClick={props.onClick}
    >
      <props.icon />
      {props.newAlarm && <NewIcon />}
    </Container>
  );
};

export const LXSmallIcon = (props: LXIconProps) => {
  return (
    <Container
      width={props.width}
      height={props.width}
      backgroundColor={props.backgroundColor}
      onClick={props.onClick}
    >
      <props.icon />
      {props.newAlarm && <SmallNewIcon />}
    </Container>
  );
};

export default LXIcon;
